import { api } from "../../gateways/unilabApi";

export async function getTipologie() {
  return await api.get("fluid/listFluidTypologies");
}

export async function getFluids() {
  return await api.get("fluid/listEnabled");
}

export async function getRefrigerants() {
  return await api.get("refrigerant/list");
}

export async function getFluidsManagementList() {
  return await api.get("fluid/fluidsManagementList");
}

export async function getFluidsManagementExportList() {
  return await api.get("fluid/exportFluids");
}

export async function saveFluids(payload) {
  return await api.post("fluid/saveFluids", payload);
}

export async function getExportModel() {
  return await api.get("fluid/getExportModel");
}
